import { Menu as MenuAntd } from 'antd';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/useMediaQuery';
import ArrowRight2Icon from '../../Common/Icons/ArrowRight2Icon';
import UserInfo, { Profile } from '../UserInfo';

import { SyncOutlined } from '@ant-design/icons';
import { styled } from '@stitches/configed';
import { Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { RouterType } from '..';

const BadgeStyled = styled('span', {
  marginLeft: 12,
  fontSize: 14,
  padding: '4px 8px',
  borderRadius: 8,
  backgroundColor: '$brand',
  color: '$content-primary',
  variants: {
    parent: {
      true: {
        display: 'inline-block',
        width: 16,
        height: 16,
        padding: 0,
        position: 'absolute',
        top: 23,
        borderRadius: 4,
      },
    },
  },
});

type Props = {
  currentUser?: Profile;
  routes: RouterType[];
  showableRoutes?: string[]; // only show routes in this array in menu
  collapsed: boolean;
  customItemSidebar?: ReactNode;
  toggleCollapsed: () => void;
  countState?: Record<string, any>;
};
const MenuMerchant = ({
  currentUser,
  routes,
  showableRoutes,
  customItemSidebar,
  toggleCollapsed,
  collapsed,
  countState
}: Props) => {
  const isLittleThanXL = useMediaQuery('(max-width: 1024px)');
  const location = useLocation();

  const arrRoute =
    showableRoutes && showableRoutes.length > 0
      ? routes.filter((x) => showableRoutes.includes(x.path))
      : routes;
  const listMenuItem = arrRoute
    .filter((x) => x.layout !== false)
    .filter((x) => x.hideInMenu !== true)
    .map(
      ({
        name,
        path,
        icon,
        routes,
        hideChildrenInMenu,
        badgeName,
        badgeLoading,
      }) => {
        if (routes && !hideChildrenInMenu) {
          return (
            <MenuAntd.SubMenu
              key={path ? path : name}
              icon={icon}
              title={
                <>
                  {name}
                  {routes.filter((x) => x.badge).length > 0 ? (
                    <BadgeStyled parent>&nbsp;</BadgeStyled>
                  ) : null}
                </>
              }
              popupOffset={[16, 0]}
            >
              {routes.map((child) => {
                return (
                  <MenuAntd.Item key={path + child.path}>
                    <Link to={path + child.path}>
                      {child.name}
                      {child.badgeLoading ? (
                        <BadgeStyled>
                          <SyncOutlined spin />
                        </BadgeStyled>
                      ) : child.badge ? (
                        <BadgeStyled>
                          {child.badge < 10 ? '0' + child.badge : child.badge}
                        </BadgeStyled>
                      ) : null}
                    </Link>
                  </MenuAntd.Item>
                );
              })}
            </MenuAntd.SubMenu>
          );
        }

        return (
          <MenuAntd.Item key={path ? path : name} icon={icon}>
            <Link to={path}>
              {name}
              {badgeLoading ? (
                <BadgeStyled>
                  <SyncOutlined spin />
                </BadgeStyled>
              ) : badgeName && countState?.[badgeName ?? ""] > 0 ? (
                <BadgeStyled>{countState?.[badgeName ?? ""] }</BadgeStyled>
              ) : null }
            </Link>
          </MenuAntd.Item>
        );
      },
    );

  const pathsSplited = location.pathname.split('/');
  const getSelectedKeys = () => {
    if (pathsSplited.length > 2) {
      const foundRoute = arrRoute.find((x) => x.path === '/' + pathsSplited[1]);
      if (foundRoute?.hideChildrenInMenu) {
        return ['/' + pathsSplited[1]];
      }
    }
    return [location.pathname];
  };

  return (
    <MenuAntd
      mode="inline"
      itemIcon={<ArrowRight2Icon />}
      expandIcon={<ArrowRight2Icon />}
      selectedKeys={getSelectedKeys()}
      onSelect={() => isLittleThanXL && toggleCollapsed()}
      inlineCollapsed={collapsed}
    >
      {isLittleThanXL && currentUser && (
        <>
          <MenuAntd.SubMenu
            key="user"
            popupOffset={[16, 0]}
            title={<UserInfo />}
          >
            <MenuAntd.Item>Hồ sơ</MenuAntd.Item>
            <MenuAntd.Item>Đăng xuất</MenuAntd.Item>
          </MenuAntd.SubMenu>
          <Fragment key="custom">{customItemSidebar}</Fragment>
        </>
      )}
      {listMenuItem}
    </MenuAntd>
  );
};

export default MenuMerchant;
